import React from 'react'
import CustomerList from '../CustomerList'

function Citizens() {
  return (
    <div>
      <CustomerList />
    </div>
  )
}

export default Citizens
